import SubUsersResource from '@/resources/SubUsersResource';

export default class SubUsers {
    constructor() {
        this.Resource = new SubUsersResource()
    }

    async getRoles () {
        const roles = await this.Resource.getRoles()
        return roles.data.roles
    }

    async getPermissions () {
        const roles = await this.Resource.getPermissions()
        return roles.data.permissions
    }

    async addSubUser(subUser) {
        const domain = await this.Resource.create(subUser)
        return domain.data.registerSubUser
    }

    async updateSubUser(subUser) {
        const domain = await this.Resource.update(subUser)
        return domain.data.updateSubUser
    }

    async delete(id) {
        const subUser = await this.Resource.delete(id)
        return subUser.data.deleteSubUser
    }
}
